import { render, staticRenderFns } from "./AssociatedLocation.vue?vue&type=template&id=37158d57&scoped=true"
import script from "./AssociatedLocation.vue?vue&type=script&lang=js"
export * from "./AssociatedLocation.vue?vue&type=script&lang=js"
import style0 from "./AssociatedLocation.vue?vue&type=style&index=0&id=37158d57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37158d57",
  null
  
)

export default component.exports